
  <b-row>
      <b-col cols="3">
          <h3>Importera förkortningslista</h3>
          <div v-if="!confirm">
              <b-form>
                  <b-select
                      v-model="from"
                      @change="changeFrom"
                      :disabled="to != 'dontExport'"
                  >
                      <b-select-option selected value="dontImport"
                          >...</b-select-option
                      >
                      <b-select-option
                          v-for="source in sources"
                          :key="source.value"
                          :value="source.value"
                          :disabled="source.disabled"
                          >{{ source.text }}</b-select-option
                      >
                  </b-select>
              </b-form>
              <br />
              <h3>Exportera förkortningslista</h3>
              <b-form>
                  <b-select
                      v-model="to"
                      @change="changeTo"
                      :disabled="from != 'dontImport'"
                  >
                      <b-select-option selected value="dontExport"
                          >...</b-select-option
                      >
                      <b-select-option
                          v-for="target in targets"
                          v-bind:key="target.value"
                          v-bind:value="target.value"
                          :disabled="target.disabled"
                          >{{ target.text }}</b-select-option
                      >
                  </b-select>
              </b-form>
          </div>
          <div v-if="confirm || safe">
              <hr v-if="safe" />
              <p>Antal förkortningar: {{ abbs.length }}</p>
              <b-form @submit.prevent="importAbbs" autocomplete="off">
                  <b-form-checkbox v-model="listForm.addToExisting"
                      >Lägg till i befintlig lista</b-form-checkbox
                  >
                  <br />
                  <div v-if="listForm.addToExisting">
                      <b-form-group label="Välj förkortningslista">
                          <b-select v-model="listForm.targetList">
                              <b-select-option
                                  v-bind:key="list.id"
                                  v-bind:value="list"
                                  v-for="list in lists"
                                  >{{ list.name }}</b-select-option
                              >
                          </b-select>
                      </b-form-group>
                  </div>
                  <div v-else>
                      <b-form-group label="Döp förkortningslistan">
                          <b-form-input
                              required
                              placeholder="..."
                              v-model="listForm.name"
                          />
                      </b-form-group>
                  </div>
                  Ämneslista
                  <b-form-checkbox
                      v-model="listForm.standard"
                      inline
                      name="standard-switch"
                      switch
                      >Standardlista</b-form-checkbox
                  >
                  <br />
                  <br />
                  <b-button @click="onCancelImport" variant="danger"
                      >Avbryt</b-button
                  >
                  <div v-if="!conflicts" class="float-right">
                      <b-button variant="primary" type="submit"
                          >Lägg till</b-button
                      >
                  </div>
              </b-form>
          </div>
      </b-col>

      <b-col >
          <div v-if="exportList">
            <b-row style="height: 80vh !important; overflow-y: auto">
              <div v-if="to == 'textontop'">
                    <h3>Exportera till TextOnTop</h3>
                </div>
                <div v-if="to == 'sttylus' || to == 'textfile'">
                    <h3>Exportera till STTylus eller textfil</h3>
                    <b-list-group>
                        <b-list-group-item
                            v-for="standard in standardLists"
                            v-bind:key="standard.value"
                        >
                            <b-row>
                                <b-col cols="4">
                                    <b>{{ standard.text }}</b>
                                </b-col>
                                <b-col>
                                    <small
                                        >{{
                                            standard.counter
                                        }}
                                        förkortningar</small
                                    >
                                </b-col>
                                <b-col>
                                    <span style="font-size: 1.2em"
                                        ><b-badge size="md">{{
                                            standard.value.split('-')[0]
                                        }}</b-badge></span
                                    >
                                    <b-button
                                        class="float-right"
                                        size="sm"
                                        @click="exportSTTylus(standard.value)"
                                        >Exportera</b-button
                                    >
                                </b-col>
                                <b-col>
                                    <b-button
                                        size="sm"
                                        variant="primary"
                                        @click="getTextfile(standard)"
                                    >
                                        <b-icon icon="download" />
                                        Hämta textfil
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-list-group-item>
                        <b-list-group-item
                            v-for="addon in addonLists"
                            v-bind:key="addon.value"
                        >
                            <b-row>
                                <b-col cols="4">
                                    {{ addon.text }}
                                </b-col>
                                <b-col>
                                    <small
                                        >{{
                                            addon.counter
                                        }}
                                        förkortningar</small
                                    >
                                </b-col>
                                <b-col>
                                    <span style="font-size: 1.2em"
                                        ><b-badge size="md">{{
                                            addon.value.split('-')[0]
                                        }}</b-badge></span
                                    >
                                    <b-button
                                        class="float-right"
                                        size="sm"
                                        @click="exportSTTylus(addon.value)"
                                        >Exportera</b-button
                                    >
                                </b-col>
                                <b-col>
                                    <b-button
                                        size="sm"
                                        variant="primary"
                                        @click="getTextfile(addon)"
                                    >
                                        <b-icon icon="download" />
                                        Hämta textfil
                                    </b-button>
                                </b-col>
                            </b-row>
                        </b-list-group-item>
                    </b-list-group>
                </div>
                <div v-if="to != 'sttylus' && to != 'textfile'" >
                  <div v-if="to == 'protype'">
                    <h3>Exportera till ProType</h3>
                  </div>
                    <b-form
                        @change="listenToEvent"
                        @submit.prevent="submitExport"
                    >
                        <b-form-radio-group
                            v-model="exportForm.standard"
                            :required="to == 'protype'"
                        >
                            <b-list-group >
                                <b-list-group-item
                                    v-for="standard in standardLists"
                                    v-bind:key="standard.value"
                                >
                                    <b-row>
                                        <b-col cols="9">
                                            <b-form-radio
                                                :value="standard.value"
                                                ><b>{{
                                                    standard.text
                                                }}</b></b-form-radio
                                            >
                                        </b-col>
                                        <b-col>
                                            <small
                                                >{{
                                                    standard.counter
                                                }}
                                                förkortningar</small
                                            >
                                        </b-col>
                                    </b-row>
                                </b-list-group-item>
                            </b-list-group>
                        </b-form-radio-group>
                        <b-form-checkbox-group v-model="exportForm.addons" >
                            <b-list-group-item
                                v-for="addon in addonLists"
                                v-bind:key="addon.value"
                            >
                                <b-row>
                                    <b-col cols="9">
                                        <b-form-checkbox :value="addon.value">{{
                                            addon.text
                                        }}</b-form-checkbox>
                                    </b-col>
                                    <b-col>
                                        <small
                                            >{{
                                                addon.counter
                                            }}
                                            förkortningar</small
                                        >
                                    </b-col>
                                </b-row>
                            </b-list-group-item>
                        </b-form-checkbox-group>
                        <hr />
                    </b-form>

                </div>
              </b-row>
              <b-row>
                <b-col>
                <b-button v-if="to != 'sttylus'" type="submit" @click="submitExport">Exportera</b-button>
                </b-col>
              </b-row>
            </div>
            <div v-if="!confirm">
                <div v-if="from == 'sttylus'">
                    <h3>Importera från STTylus</h3>
                    <b-form @submit.prevent="importSTTylus">
                        Ange listans ID:
                        <b-row>
                            <b-col cols="4">
                                <b-form-input
                                    :formatter="sttylusIdFormatter"
                                    v-model="form.id"
                                />
                            </b-col>
                        </b-row>
                        <br />
                        <b-button type="submit">Hämta</b-button>
                    </b-form>
                </div>

                <div v-if="from == 'protype'">
                    <h3>Importera från ProType</h3>
                    <b-jumbotron>
                        <template #lead>
                            <p>
                                För import av listor och användare från ProType
                                rekommenderas
                                <a href="https://sttylus.se/utx/"
                                    >UTX-programmets Förkortningsverktyg</a
                                >.<br />
                                Där kan du konvertera från flera filtyper till
                                textfilsformat.
                            </p>
                        </template>
                        Annars hittar du din användare under
                        <code>Users/</code> där du har ProType installerat. För
                        varje förkortningslista finns ytterligare en katalog och
                        när du hittat din lista det filen som heter antingen
                        <code>wordlist</code> eller <code>wordlist.dat</code> du
                        ska välja för uppladdning i formuläret nedan.
                    </b-jumbotron>
                    <div v-if="online">
                        <b-form @submit.prevent="uploadProType">
                            <b-form-file v-model="form.file" accept=".dat" />
                            <hr />
                            <b-button type="submit">Ladda upp</b-button>
                        </b-form>
                    </div>
                    <div v-else></div>
                </div>
                <div v-if="from == 'textontop' || from == 'illumitype'">
                    <div v-if="!uploaded">
                        <h3>
                            Importera från
                            <span v-if="from == 'textontop'">TextOnTop</span>
                            <span v-else>IllumiType</span>
                        </h3>
                        <b-form @submit.prevent="uploadJSONList">
                            <b-form-file v-model="form.file" accept=".json" />
                            <hr />
                            <b-button type="submit">Ladda upp</b-button>
                        </b-form>
                        {{ output }}
                    </div>
                    <div v-else>
                        <h3>
                            Välj lista från
                            <span v-if="from == 'textontop'">TextOnTop</span>
                            <span v-else>IllumiType</span>
                        </h3>
                        <b-form @submit.prevent="selectUploadedList">
                            <b-select
                                v-model="selectedJSONList"
                                @change="changeSelectedJSONList"
                            >
                                <b-select-option
                                    v-bind:key="i + '_' + listName"
                                    v-bind:value="listName"
                                    v-for="(listName, i) in importableListNames"
                                    >{{ listName }}</b-select-option
                                >
                            </b-select>
                            <br />
                            <br />
                            Det finns {{ countJSONAbbs }} förkortningar i denna
                            lista.
                            <br />
                            <b-button type="submit">Välj lista</b-button>
                        </b-form>
                    </div>
                </div>
                <div v-if="from == 'textfile'">
                    <h3>Importera från textfil</h3>

                    <b-form @submit.prevent="uploadTxt">
                        <b-form-textarea
                            id="textarea"
                            v-model="txt"
                            placeholder="Klistra in förkortningar enligt formatet:
förkortning=fras
förkortning=fras"
                            rows="20"
                            max-rows="6"
                        ></b-form-textarea>
                        <hr />
                        <b-button type="submit">Importera</b-button>
                    </b-form>
                </div>
            </div>
            <div v-if="confirm || safe">
                <b-row>
                    <b-col cols="8">
                        <h3 v-if="safe">Redigera importerade förkortningar</h3>
                        <h3 v-else>Kontrollera importerade förkortningar</h3>
                    </b-col>
                    <b-col>
                        <span v-if="nConflicts > 0">
                            <b-badge class="float-right" variant="warning">
                                Det finns
                                <span v-if="nConflicts == 1">ett</span>
                                <span v-else>{{ nConflicts }}</span> fel eller
                                <span v-if="nConflicts == 1">konflikt</span>
                                <span v-else>konflikter</span> att korrigera
                            </b-badge>
                        </span>
                        <span class="float-right">
                            Ersätt alla
                            <b-form-checkbox
                                class="pt-1"
                                inline
                                model="replaceAll"
                                @change="changeOverwriteAll"
                            ></b-form-checkbox>
                        </span>
                    </b-col>
                    <b-col>
                        <b-pagination
                            class="float-right"
                            v-model="currentPage"
                            :totalRows="abbs.length"
                            :perPage="10"
                            aria-controls="abbs"
                        />
                    </b-col>
                </b-row>
                <b-form autocomplete="off">
                    <div style="height: 68vh !important; overflow-y: auto">
                        <b-table
                            small
                            responsive
                            hover
                            striped
                            :perPage="10"
                            :currentPage="currentPage"
                            :items="abbs"
                            :fields="abbFields"
                            :sort-by="sortBy"
                            :sort-desc="sortDesc"
                            @sort-changed="sortChanged"
                        >
                            <template v-slot:cell(abb)="row">
                                <div
                                    style="
                                        min-width: 110px;
                                        max-width: 100px;
                                        white-space: normal;
                                    "
                                >
                                    <b-form-input
                                        v-model="row.item.abb"
                                        size="md"
                                        class="mb-0"
                                        @change="onUpdateAbb(row.item)"
                                        :state="row.item.validabb"
                                    />
                                </div>
                            </template>
                            <template v-slot:cell(word)="row">
                                <b-form-input
                                    v-model="row.item.word"
                                    size="md"
                                    class="mb-0"
                                    @change="onUpdateWord(row.item)"
                                    :state="row.item.validword"
                                />
                            </template>
                            <template v-slot:cell(issue)="row">
                                <span v-if="debug">
                                    <b-button
                                        size="sm"
                                        :id="'popover' + row.item.id"
                                        >?</b-button
                                    >
                                    <b-popover
                                        :target="'popover' + row.item.id"
                                        triggers="hover"
                                        placement="left"
                                    >
                                        validabb: {{ row.item.validabb }}
                                        <br />
                                        validword: {{ row.item.validword }}
                                        <br />
                                        dup: {{ row.item.notduplicate }}
                                        <br />
                                        issue: {{ row.item.issue }}
                                        <br />
                                    </b-popover>
                                </span>
                                <span v-if="row.item.notduplicate != null">
                                    <b-badge
                                        variant="warning"
                                        v-if="!row.item.notduplicate"
                                        >Konflikt</b-badge
                                    >
                                    <br />
                                    <span
                                        v-if="
                                            row.item.issue ==
                                            '__textduplicate__'
                                        "
                                        >Dubblett i textfil</span
                                    >
                                    <span
                                        v-else-if="
                                            row.item.issue ==
                                            '__importduplicate__'
                                        "
                                        >Dubblett vid importering</span
                                    >
                                    <span v-else>
                                        <b-form-checkbox
                                            v-model="row.item.overwrite"
                                            @change="
                                                changeOverwriteAbb(row.item)
                                            "
                                        >
                                            Ersätt
                                            <i>{{ row.item.issue }}</i>
                                        </b-form-checkbox>
                                    </span>
                                </span>
                                <span
                                    v-if="
                                        row.item.notduplicate == null &&
                                        (row.item.validword != null ||
                                            row.item.validabb != null)
                                    "
                                >
                                    <b-badge variant="danger"
                                        >Fel format</b-badge
                                    >
                                    <br />
                                    <span
                                        v-if="
                                            row.item.issue == '__formaterror__'
                                        "
                                        >Fel format vid importering</span
                                    >
                                    <span v-else>{{ row.item.issue }}</span>
                                </span>
                            </template>
                            <template v-slot:cell(delete)="row">
                                <b-button
                                    class="float-right"
                                    variant="danger"
                                    @click="onDeleteAbb(row.item)"
                                >
                                    <b-icon icon="trash" />
                                </b-button>
                            </template>
                        </b-table>
                    </div>
                    <b-button @click="resolveConflicts(null)"
                        >Kontrollera fel/konflikter</b-button
                    >
                </b-form>
            </div>
        </b-col>
        <ResolveConflicts />
    </b-row>
